import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_fortiumbot.png",
      alt: "Estratégias Fortiumbot",
    },
    title: "Fortiumbot: transformando desafios em oportunidades.",

    // String ou array de strings
    text: [
      "Na Fortiumbot, acreditamos que cada desafio no mercado financeiro é uma oportunidade de crescimento. Automatizamos operações de trading com estratégias inteligentes, maximizando resultados e minimizando riscos. Transforme incertezas em conquistas com a precisão e eficiência dos nossos bots.",
    ],
    testimonial: {
      text: "Consistência e segurança, venha operar com a Fortiumbot",
      author: {
        name: "Fortiumbot",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias Fortiumbot",
    heading: "Algoritmos exclusivos para seus investimentos.",
    subtitle:
      "Na Fortiumbot, nossas estratégias são projetadas para capturar retornos consistentes, mesmo em um mercado desafiador. Utilizamos uma combinação avançada de indicadores e parâmetros, focados em eficiência e segurança. Todos os nossos bots são rigorosamente testados e aprovados em contas reais, garantindo desempenho confiável. Confie na Fortiumbot para transformar oportunidades em resultados.",
  },

  cta: {
    title: "Chegou a hora de automatizar",
    subtitle: "Ative seus bots hoje mesmo.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Fortiumbot",
    col1: [
      "A Fortiumbot é especialista em automação de trading na B3, combinando estratégias inteligentes e indicadores avançados para capturar oportunidades de mercado com precisão. Nosso foco é oferecer resultados consistentes com segurança. Automatize suas operações e alcance seus objetivos com a Fortiumbot! ",
    ],
    // col2: [
    //   "Nossa missão é ajudar traders de todos os níveis a aproveitar as vantagens da automação no mercado financeiro.",
    // ],
  },

  stats: {
    title: "Números da Fortiumbot",
    subtitle: "Nossa experiência real acessível aos nossos clientes",
    data: [
      {
        value: "+500K",
        description: "Contratos executados",
      },
      {
        value: "100%",
        description: "Clientes satisfeitos",
      },
      {
        value: "100%",
        description: "dos nossos robôs lucrativos",
      },
    ],
  },

  features: {
    title: "Por que utilizar os nossos robôs?",
    subtitle: "Veja quais as principais vantagens dos robôs Fortiumbot.",
    data: [
      {
        icon: iconsSet.click,
        title: "Precisão",
        description: "Bots que operam com precisão, eliminando decisões emocionais.",
      },
      {
        icon: iconsSet.money,
        title: "Resultados",
        description: "Estratégias que garantem resultados sólidos, mesmo em alta volatilidade.",
      },
      {
        icon: iconsSet.test_tube,
        title: "Confiabilidade",
        description: "Bots testados rigorosamente em contas reais, garantindo confiabilidade.",
      },
      {
        icon: iconsSet.lock,
        title: "Segurança",
        description: "Ferramentas como Stop Loss e Take Profit para proteger e potencializar ganhos.",
      },
      {
        icon: iconsSet.editParams,
        title: "Otimização",
        description: "Bots programados para operar nos momentos de maior liquidez e volatilidade.",
      },
      {
        icon: iconsSet.growth,
        title: "Lucro máximo",
        description: "Saídas de operação estrategicamente programadas para controlar perdas.",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "A FortiumBot oferece, a nós investidores novatos e experientes, opções para todos os perfis com uma assessoria sólida e diária. É uma excelente opção que deve constar na carteira de todo mundo que está interessado em retorno financeiro. Uso e recomendo fortemente!",
      author: "Daniel Jeffmann - RS",
      job: "Empresário",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Sempre busquei me aprofundar no mercado de Daytrade, mas nunca consegui o tempo hábil para isso, e por saber que se trata de um segmento com alta relação risco x retorno, principalmente para iniciantes, encontrei na FortiumBot, a possibilidade de operar com segurança, com ganhos consistentes e ainda consigo manter o foco no meu trabalho, sendo que os resultados são muito positivos, e o atendimento da equipe é sempre muito ágil e didático. Recomendo!",
      author: "Conrado Victor - MG",
      job: "Empresário",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Fortiumbot",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
